import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import { GET_EXCHANGE_JOURNEYS, GET_JOURNEY_SEARCH_FOR_EXCHANGE } from 'store/queries/index';
import { Spinner } from 'admin-components/components';
import AgentPortalError from 'errors/AgentPortalError';
import { Row, Column } from 'components/shared/Layout';

const ExchangeJourneySearch = ({ children, variables, onCompleted, isOnHoldOrProvisionalBooking, isSwapStations, isOverrideRule }) => {
  const getExchangeQuery =
    isOnHoldOrProvisionalBooking || isSwapStations || isOverrideRule ? GET_EXCHANGE_JOURNEYS : GET_JOURNEY_SEARCH_FOR_EXCHANGE;
  const { data, loading, error } = useQuery(getExchangeQuery, {
    variables: { ...variables, useNewLoyaltySystem: true },
    onCompleted,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });

  if (loading) {
    return (
      <Row height="100vh">
        <Column alignItems="center" justifyContent="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  if (error) {
    throw new AgentPortalError(error);
  }

  const exchangeSearch = data?.journeySearchForExchange || data?.exchangeSearch || {};

  return children(exchangeSearch);
};

ExchangeJourneySearch.propTypes = {
  children: PropTypes.func.isRequired,
  variables: PropTypes.shape({
    reference: PropTypes.string.isRequired,
    origin: PropTypes.string,
    destination: PropTypes.string,
    outboundDate: PropTypes.string,
    inboundDate: PropTypes.string,
    currency: PropTypes.string
  }).isRequired,
  onCompleted: PropTypes.func,
  isOnHoldOrProvisionalBooking: PropTypes.bool,
  isSwapStations: PropTypes.bool,
  isOverrideRule: PropTypes.bool
};

export default ExchangeJourneySearch;
